const pageTypes = [
  { key: 'index', eventCategory: 'airbaltic_career_logo', eventLabel: 'airbaltic_career_logo', en: '', lv: '' },
  { key: 'vacancies', eventCategory: 'jobs', en: '/vacancies', lv: '/vakances' },
  { key: 'vacancy', en: '/vacancies/', lv: '/vakances/' },
  { key: 'team_pilots', eventCategory: 'teams', en: '/teams/pilots', lv: '/komandas/piloti' },
  {
    key: 'team_cabin_crew',
    eventCategory: 'teams',
    eventLabel: 'cabin_crew',
    en: '/teams/cabin-crew',
    lv: '/komandas/stjuarti'
  },
  {
    key: 'team_aircraft_technicians',
    eventCategory: 'teams',
    eventLabel: 'aircraft_technicians',
    en: '/teams/aircraft-technicians',
    lv: '/komandas/tehniska-apkope'
  },
  { key: 'team_office', eventCategory: 'teams', eventLabel: 'office', en: '/teams/office', lv: '/komandas/ofiss' },
  { key: 'team_airport', eventCategory: 'teams', eventLabel: 'airport', en: '/teams/airport', lv: '/komandas/lidosta' },
  {
    key: 'team_pilot_academy',
    eventCategory: 'teams',
    eventLabel: 'pilot_academy',
    en: '/teams/pilot-academy',
    lv: '/komandas/pilotu-akademija'
  },
  {
    key: 'team_training_centre',
    eventCategory: 'teams',
    eventLabel: 'training_centre',
    en: '/teams/training-centre',
    lv: '/komandas/apmacibu-centrs'
  },
  {
    key: 'team_baltic_cargo_centre',
    eventCategory: 'teams',
    eventLabel: 'baltic_cargo_centre',
    en: '/teams/baltic-cargo-centre',
    lv: '/komandas/baltijas-kravu-centrs'
  },
  { key: 'internship', eventCategory: 'internship', en: '/internship', lv: '/prakse' },
  {
    key: 'internship_skytech_vacancy_page',
    eventCategory: 'internship',
    eventLabel: 'skytech',
    en: 'skytech',
    lv: 'skytech'
  },
  {
    key: 'university_internship_vacancy',
    eventCategory: 'internship',
    eventLabel: 'university_internship',
    en: 'university',
    lv: 'universitate'
  },
  {
    key: 'school_internship_vacancy',
    eventCategory: 'internship',
    eventLabel: 'school_internship',
    en: 'school',
    lv: 'skola'
  },
  { key: 'contacts', eventCategory: 'life_at_airbaltic', eventLabel: 'contacts', en: '/contacts', lv: '/kontakti' },
  { key: 'liab_culture', eventCategory: 'life_at_airbaltic', eventLabel: 'culture', en: '/culture', lv: '/kultura' },
  { key: 'liab_benefits', eventCategory: 'life_at_airbaltic', eventLabel: 'benefits', en: '/benefits', lv: '/bonusi' },
  {
    key: 'liab_leadership',
    eventCategory: 'life_at_airbaltic',
    eventLabel: 'leadership-program',
    en: '/leadership-program',
    lv: '/lideribas-programma'
  },
  { key: 'liab_news', eventCategory: 'life_at_airbaltic', eventLabel: 'latest_news', en: '/news', lv: '/zinas' },
  { key: 'talent_pool', en: '/talent-pool', lv: '/talantu-rezerve' }
]

export default class GTM {
  static doDataLayerPush(data) {
    window.dataLayer = window.dataLayer ?? []
    window.dataLayer.push(data)
  }

  // Header

  static headerPageChange(path) {
    const pageType = this.getPageType(path)
    const data = this.getBaseData()
    data.event = 'header_clicks'
    data.eventCategory = pageType.eventCategory ?? ''
    data.eventLabel = pageType.eventLabel ?? pageType.eventCategory ?? ''

    this.doDataLayerPush(data)
  }

  static languageSwitch(fromLang, toLang) {
    const data = this.getBaseData()
    data.event = 'language_changes'
    data.eventCategory = fromLang
    data.site_language = toLang

    this.doDataLayerPush(data)
  }

  // Footer

  static pressSubmitCv() {
    const data = this.getBaseData()
    data.event = 'upload_your_cv'

    this.doDataLayerPush(data)
  }

  static newsletterSubmit() {
    const data = this.getBaseData()
    data.event = 'email_subscription'

    this.doDataLayerPush(data)
  }

  static pressAirBaltic() {
    const data = this.getBaseData()

    data.event = 'footer_link_clicks'
    data.eventCategory = 'airbaltic_website'

    this.doDataLayerPush(data)
  }

  static pressContactUs() {
    const data = this.getBaseData()
    data.event = 'footer_link_clicks'
    data.eventCategory = 'contact_us'

    this.doDataLayerPush(data)
  }

  static pressSocial(social) {
    const data = this.getBaseData()

    Object.assign(data, {
      event: 'social_media_icons_clicks',
      eventCategory: social
    })

    this.doDataLayerPush(data)
  }

  // Form

  static pressFillVacancyForm(data) {
    const gtmData = { ...this.getBaseData(), ...data }

    this.doDataLayerPush(gtmData)
  }

  static pressFormApply(data) {
    const gtmData = { ...this.getBaseData(), ...data }
    gtmData.event = 'apply_now_button'

    if (gtmData.page_type === 'talent_pool') {
      gtmData.job_title = 'talent_pool'
      delete gtmData.apply_until
    }

    this.doDataLayerPush(gtmData)
  }

  static formSuccess(data) {
    const gtmData = { ...this.getBaseData(), ...data }
    gtmData.event = 'application_successfully_submitted'

    this.doDataLayerPush(gtmData)
  }

  // Internship

  static pressApplyInternship() {
    const data = this.getBaseData()
    data.event = 'apply_for_internship_button'
    data.eventCategory = 'click'

    this.doDataLayerPush(data)
  }

  // Functions

  static getBaseData() {
    const pageType = this.getPageType()
    const nuxtApp = useNuxtApp()

    return {
      site_language: nuxtApp.$i18n.locale.value,
      page_type: pageType.key
    }
  }

  static getPageType(pagePath = '') {
    const { path } = useRoute()
    const nuxtApp = useNuxtApp()
    const locale = nuxtApp.$i18n.locale.value

    let result = {}

    if (pagePath) {
      pageTypes.forEach((pageType) => {
        if (pagePath.match(`${pageType[locale]}`)) {
          result = pageType
        }
      })

      return result
    }

    pageTypes.forEach((pageType) => {
      if (path.match(`${pageType[locale]}`)) {
        result = pageType
      }
    })

    return result
  }
}
